import { TypographyOptions } from '@material-ui/core/styles/createTypography';

const font = 'Barlow Semi Condensed, sans-serif';

const typography: TypographyOptions = {
  fontFamily: font,
};

export default typography;
